import {Button, Snackbar, SnackbarContent, useTheme} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import {useDispatch, useSelector} from "react-redux";
import {closeSnackBar} from "../../store/reducers/errors";

const HomeMadeSnackbar = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const snackBarState = useSelector((state) => state.errors.snackBarState);

    const SnackBarActions = () => {
        return (
            <>
                <Button
                    style={{
                        color: 'white',
                        backgroundColor: theme.palette.action.active,
                        borderRadius: '4px !important'
                    }}
                    onClick={() =>  dispatch(closeSnackBar())}
                >
                    <CloseIcon/>
                </Button>
            </>
        )
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            dispatch(closeSnackBar())
        }
    }

    return (
        <Snackbar
            autoHideDuration={1500}
            open={!!snackBarState.isOpen}
            color={snackBarState.color}
            key={'error-snackbar'}
            onClose={handleClose}
            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
        >
            <SnackbarContent
                style={{
                    backgroundColor: snackBarState.color,
                    color: 'white'
                }}
                message={snackBarState.message}
                action={snackBarState.closeAction && <SnackBarActions/>}
            />
        </Snackbar>
    )
}
export default HomeMadeSnackbar
